<template>
  <v-app id="vapp" class="darkcmpbk">
    <!--version 0.9.02-->
    <!--//@*/*
    //    *RPD Loiter Appv0.91
    //    * Copyright (c) 2024, Blue Cover Six LLC . All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <v-row class="menu-bar-row">
      <v-col cols="12">
        <brandbar></brandbar>
      </v-col>
    </v-row>

    <v-main id="main">
      <Transition name="fade-transition" mode="out-in">
        <router-view />
      </Transition>
    </v-main>
  </v-app>
</template>

<style>
/* 0 media q */
@media (min-width: 0px) {
  .v-main {
    padding: 5px 0 0 0 !important;
  }
  .menu-bar-row {
    height: 50px;
    flex-grow: 0 !important;
  }

  #vapp {
    /* background-color: var(--v-background-base); */
    overflow-x: hidden;
    /* overflow-y: auto; */
    /* background-color: orange; */
    min-height: 100%;
    max-width: 768px;
    margin: 0 auto;
    /* background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
    background-size: cover; */
  }

  .v-toolbar {
    max-width: 768px;
    margin: 0 auto;
  }

  #menu-bar-large .v-toolbar__content,
  #menu-bar-mobile .v-toolbar__content {
    width: 100%;
    max-width: 768px;
    height: 50px !important;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;
  }

  #menu-bar-large img.img1 {
    width: 48px;
  }

  #menu-bar-mobile .v-application:deep .primary {
    background-color: aliceblue !important;
    border-color: aliceblue !important;
  }

  .my-active-class {
    color: orange;
  }

  #v-navigation-bar {
    background-color: #2c3e50;
  }
  .bk-color {
    margin: 5px;
    border-radius: 4px;
  }
  .bk-color:hover {
    background: #bbdefb;
  }
  .bk-color:active {
    background: #e3f2fd;
  }

  /* .img2 img {
    width: 400px;
  }

  .img3 img {
    width: 400px;
  } */

  #menu-bar-large a {
    color: white;
    text-decoration: none;
    font-size: 1.2rem;
  }

  #menu-bar-large a:hover {
    color: #e3cc67;
  }

  #menu-bar-large a:active {
    color: #b08533;
  }

  .swal2-popup {
    /* font-size: 1.15rem !important;*/
    font-family: "Roboto", sans-serif !important;
  }
  .v-btn--active.no-active::before {
    opacity: 0 !important;
  }

  .v-btn--active.no-active:not(:hover)::before {
    opacity: 0 !important;
  }
}

@media only screen and (max-width: 600px) {
  #vapp {
    max-width: 768px;
  }
}

@media (min-width: 768px) {
}

@media (min-width: 1025px) {
  #vapp {
    /* background-image: url("../images/reno-hero_1920.png"); */
    /*background-image: url("../images/hero_placeholder.jpg");
    background-position: 0 100px;*/
    max-width: 768px;
  }
}

@media (min-width: 2048px) {
}
</style>

<script>
import brandbar from "./brandbar.vue";
import { bus_common } from "../mixins/bus_common";
export default {
  name: "App",
  mixins: [bus_common],
  components: { brandbar },

  data() {
    return {
      zIndex: 4000,
      drawer: false,
      group: null,
    };
  },
  watch: {
    "$store.state.loader_visible": function () {
      //console.log("app loader_visible " + this.$store.state.loader_visible );
    },
  },
  computed: {
    overlay: function () {
      return this.$store.state.loader_visible;
    },
  },
  methods: {
    logout() {
      this.swall_diag(
        "Log Out?",
        "Are you sure you would like to log out?",
        "question",
        null,
        "Yes",
        "No",
        null
      );
    },
  },
  created() {
    this.show_loader(true);
  },
};
</script>
